<template>
  <div id="app">
    <el-container>
      <el-header>
        <nav-menu></nav-menu>
      </el-header>
      
      <el-main>
        <router-view/>
      </el-main>
      
      <el-footer>
        <site-footer></site-footer>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import NavMenu from '@/components/NavMenu.vue'
import SiteFooter from '@/components/SiteFooter.vue'

export default {
  name: 'App',
  components: {
    NavMenu,
    SiteFooter
  }
}
</script>

<style lang="scss">
#app {
  /* 与 body 一致，保证中文回退字体（苹方/微软雅黑等）在全站生效，避免仅拉丁栈导致字重异常 */
  font-family: inherit;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.el-header {
  padding: 0;
  height: auto !important;
}

.el-main {
  padding: 0;
  min-height: calc(100vh - 120px);
}

.el-footer {
  padding: 0;
  height: auto !important;
}
</style>
